import CalendarEventsStore from '../../store/CalendarEventsStore';
import CalendarInstanceKeyItemIdIndex from '../../store/CalendarInstanceKeyItemIdIndex';
import deleteCalendarEventsFromCache from './deleteCalendarEventsFromCache';
import { CalendarEventKey } from 'mini-calendar-event-types';
import { getCalendarEventsStore, getCalendarInstanceKeyItemIdIndex } from '../../store/store';

/**
 * Internal method that deletes events to cache based on instance key.
 * @param instanceKeys - instance keys of events to delete.
 * @returns the calendar keys of events that were deleted.
 */
export default function deleteCalendarEventsByInstanceKeysFromCache(
    instanceKeys: string[]
): CalendarEventKey[] {
    const store: CalendarEventsStore = getCalendarEventsStore();
    const instanceKeyIndex: CalendarInstanceKeyItemIdIndex = getCalendarInstanceKeyItemIdIndex();
    let keys: CalendarEventKey[] = [];
    instanceKeys.forEach(key => {
        const events = store.getCalendarEvents(instanceKeyIndex.getAllItemIds(key));
        keys = keys.concat(deleteCalendarEventsFromCache(events));
    });
    return keys;
}
